import { render, staticRenderFns } from "./UnsavedChangesDialog.vue?vue&type=template&id=0b6ad0ea&scoped=true"
import script from "./UnsavedChangesDialog.vue?vue&type=script&lang=js"
export * from "./UnsavedChangesDialog.vue?vue&type=script&lang=js"
import style0 from "./UnsavedChangesDialog.vue?vue&type=style&index=0&id=0b6ad0ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6ad0ea",
  null
  
)

export default component.exports